import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { Loader } from 'core/components';

function CancelUncancelResultTemplate({ cancelUncancelResultViewStore: { data }, t }) {
	if (!data) return <Loader />;

	var isSuccess = data.result === 'success';
	var isPartial = data.result === 'partial';
	var isFailed = data.result === 'failed';

	return (
		<section className="canceluncancelresult">
			<div className="ReactModal__header">
				<h2 className="spc--bottom--sml">
					{isSuccess ? (
						<i className="canceluncancelresult__icon--success fa fa-check-circle spc--right--sml" />
					) : isPartial ? (
						<i className="canceluncancelresult__icon--warning fa fa-exclamation-circle spc--right--sml" />
					) : (
						<i className="canceluncancelresult__icon--error fa fa-times-circle spc--right--sml" />
					)}
					{t('CANCELUNCANCELVIEW.CANCELUNCANCELRESULT')}
				</h2>
			</div>

			<div className="ReactModal__body">
				<ResultSection title="Order" result={data.orderResult} t={t} />
				<ResultSection title="Order Lines" result={data.orderLineResult} t={t} />
				<ResultSection title="Fulfillment Orders" result={data.fulfillmentOrderResult} t={t} />
			</div>

			<div className="ReactModal__footer"></div>
		</section>
	);
}

function ResultSection({ title, result, t }) {
	if (!result) return null;

	var hasSuccess = result.successMessages && result.successMessages.length > 0;
	var hasError = result.errorMessages && result.errorMessages.length > 0;
	if (!hasSuccess && !hasError) return <div></div>;

	return (
		<div className="canceluncancelresult__section">
			<h4 className="canceluncancelresult__title">{t ? t(title) : title}</h4>
			<ul className="canceluncancelresult__messages">
				{hasSuccess &&
					result.successMessages.map(function(msg, i) {
						return (
							<li key={'success-' + i} className="canceluncancelresult__message canceluncancelresult__message--success">
								<i className="fa fa-check-circle spc--right--nano" /> {msg}
							</li>
						);
					})}

				{hasError &&
					result.errorMessages.map(function(msg, i) {
						return (
							<li key={'error-' + i} className="canceluncancelresult__message canceluncancelresult__message--warning">
								<i className="fa fa-times-circle spc--right--nano" /> {msg}
							</li>
						);
					})}
			</ul>
		</div>
	);
}

export default defaultTemplate(CancelUncancelResultTemplate);
